module.exports = __webpack_public_path__ + "static/media/questionnaire-step4-mobile.1d7f0a54.png";